import React from 'react';
import BaseModal from '../common/BaseModal';

const DiscountModal = ({
  show,
  availableDiscounts,
  appliedDiscounts,
  onApplyDiscount,
  onRemoveDiscount,
  onClose
}) => {
  // Zabezpieczenie przed null/undefined
  const safeAvailableDiscounts = Array.isArray(availableDiscounts) ? availableDiscounts : [];
  const safeAppliedDiscounts = Array.isArray(appliedDiscounts) ? appliedDiscounts : [];

  return (
    <BaseModal
      isOpen={show}
      onClose={onClose}
      title="🏷️ Dostepne rabaty"
      size="md"
      headerStyle={{
        border: '1px solid var(--purple)', color: 'var(--purple)' ,
        padding: '0.75rem 1rem',
        borderRadius: '0.375rem 0.375rem 0 0',
      }}
      bodyStyle={{ padding: '0.75rem', maxHeight: '60vh', overflowY: 'auto' }}
    >
      {safeAvailableDiscounts.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "var(--text-muted)",
            fontSize: "11px",
          }}
        >
          <span style={{ fontSize: "24px", display: "block", marginBottom: "0.5rem" }}>🏷️</span>
          <p style={{ margin: 0 }}>Brak dostepnych rabatow</p>
        </div>
      ) : (
        <div style={{ display: "grid", gap: "0.5rem" }}>
          {safeAvailableDiscounts.map((discount) => {
            const limitMiesieczny = discount.limit_miesieczny_aktywny && discount.limit_miesieczny_kwota > 0;
            const wykorzystano = discount.wykorzystana_kwota_miesiac || 0;
            const pozostalo = limitMiesieczny ? (discount.limit_miesieczny_kwota - wykorzystano) : null;

            return (
            <div
              key={discount.id}
              style={{
                border: "1px solid var(--border)",
                borderLeft: `3px solid ${discount.status_dostepnosci !== 'DOSTEPNY' ? 'var(--danger)' : 'var(--purple)'}`,
                borderRadius: "4px",
                padding: "0.5rem",
                backgroundColor: discount.status_dostepnosci !== 'DOSTEPNY' ? 'var(--danger-light)' : "var(--bg)",
                opacity: discount.status_dostepnosci !== 'DOSTEPNY' ? 0.7 : 1,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <h6
                    style={{ margin: "0 0 0.25rem 0", fontWeight: "600", fontSize: "11px" }}
                  >
                    {discount.nazwa}
                  </h6>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "0.2rem",
                        color: "var(--success)",
                        fontWeight: "600",
                        fontSize: "11px",
                        backgroundColor: "var(--success-light)",
                        padding: "0.15rem 0.4rem",
                        borderRadius: "3px",
                      }}
                    >
                      {discount.typ_rabatu === "procentowy" ? (
                        <>{discount.wartosc}%</>
                      ) : (
                        <>{discount.wartosc} zl</>
                      )}
                    </span>
                    {discount.opis && (
                      <span style={{ fontSize: "10px", color: "var(--text-muted)" }}>
                        {discount.opis}
                      </span>
                    )}
                  </div>
                  {limitMiesieczny && (
                    <div style={{ marginTop: "4px", fontSize: "9px", color: (pozostalo || 0) <= 0 ? "var(--danger)" : "var(--warning)" }}>
                      Limit: {discount.limit_miesieczny_kwota} zl | Wykorzystano: {Number(wykorzystano || 0).toFixed(2)} zl | Pozostalo: {Number(pozostalo || 0).toFixed(2)} zl
                    </div>
                  )}
                  {discount.status_dostepnosci !== 'DOSTEPNY' && (
                    <div style={{ marginTop: "4px", fontSize: "9px", color: "var(--danger)", fontWeight: "500" }}>
                      Limit wyczerpany
                    </div>
                  )}
                </div>
                <button
                onClick={() => onApplyDiscount(discount.id)}
                disabled={safeAppliedDiscounts.some(
                  (d) => d.id === discount.id,
                )}
                style={{
                  padding: "4px 10px",
                  fontSize: "11px",
                  backgroundColor: safeAppliedDiscounts.some(
                    (d) => d.id === discount.id,
                  )
                    ? "var(--text-muted)"
                    : "var(--success)",
                  color: "#fff" ,
                  cursor: safeAppliedDiscounts.some(
                    (d) => d.id === discount.id,
                  )
                    ? "not-allowed"
                    : "pointer",
                  fontWeight: "600",
                }}
              >
                  {safeAppliedDiscounts.some((d) => d.id === discount.id)
                    ? "Dodany"
                    : "+ Dodaj"}
                </button>
              </div>
            </div>
            );
          })}
        </div>
      )}

      {/* Zastosowane rabaty */}
      {safeAppliedDiscounts.length > 0 && (
        <div
          style={{
            marginTop: "0.75rem",
            paddingTop: "0.75rem",
            borderTop: "1px solid var(--border)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <h6 style={{ margin: 0, fontWeight: "600", fontSize: "11px", color: "var(--text-muted)" }}>
              Zastosowane rabaty
            </h6>
            <button
              onClick={() => {
                safeAppliedDiscounts.forEach(d => onRemoveDiscount(d.czasowe_id));
              }}
              style={{
                background: "var(--danger)",

                color: "#fff" ,
                cursor: "pointer",
                fontSize: "11px",
                padding: "4px 10px",
                fontWeight: "500",
              }}
            >
              Usun wszystkie
            </button>
          </div>
          <div style={{ display: "grid", gap: "0.3rem" }}>
            {safeAppliedDiscounts.map((discount) => (
              <div
                key={discount.id}
                style={{
                  background: "var(--success-light)",
                  padding: "0.5rem",
                  borderRadius: "4px",
                  borderLeft: "3px solid var(--success)",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: "500", fontSize: "11px" }}>
                    {discount.nazwa}
                  </span>
                  <span style={{ color: "var(--success)", fontWeight: "600", fontSize: "11px" }}>
                    -{discount.kwota_rabatu?.toFixed(2)} zl
                  </span>
                </div>
                {discount.info && (
                  <div style={{ fontSize: "9px", color: "var(--text-secondary)", marginTop: "2px" }}>
                    {discount.info}
                  </div>
                )}
                {discount.pozostaly_limit_po !== undefined && discount.pozostaly_limit_po !== null && (
                  <div style={{ fontSize: "9px", color: "var(--warning)", marginTop: "2px" }}>
                    Pozostaly limit: {Number(discount.pozostaly_limit_po).toFixed(2)} zl
                  </div>
                )}
                <button
                  onClick={() => onRemoveDiscount(discount.czasowe_id)}
                  style={{
                    marginTop: "0.4rem",
                    width: "100%",
                    background: "var(--danger)",

                    color: "#fff" ,
                    cursor: "pointer",
                    fontSize: "11px",
                    padding: "4px 10px",
                    fontWeight: "500",
                  }}
                >
                  Usun ten rabat
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </BaseModal>
  );
};

export default React.memo(DiscountModal);
